
<div class="row">
  <div class="columns">
    <gw-audits-group class="audits-list__group" [audits]="audits" (auditCreated)="loadAudits()" (auditRemoved)="onRemoveAudit()"></gw-audits-group>
    <gw-pagination class="audits-list__pagination" *ngIf="audits &amp;&amp; audits.length &gt; 0" [totalElementsAmount]="totalAudits" [currentPage]="filterService?.page" [currentLimit]="filterService?.limit" (changePage)="changePage($event)" (changeLimit)="changeLimit($event)"></gw-pagination>
  </div>
</div>